import React, { useEffect, useState } from 'react';
import { RootState, useSelector } from '../redux/store';
import { Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import axios from '../utils/axios';

interface ProvinceTypeProps {
  deviceProvince: string | undefined;
  changeHandler: (deviceProvince: string | null) => void;
}

function DeviceProvincePicker(props: ProvinceTypeProps) {
  const { deviceProvince } = props;
  const { t } = useTranslation(['translation', 'custom']);
  const { loaded } = useSelector((state: RootState) => state.user);

  const [provinceList, setProvinceList] = useState<string[]>([]);

  useEffect(() => {
    axios
      .get('/api/v2/device/states')
      .then((res) => {
        let provinceL = res.data.data.map((c: any) => c.states);

        provinceL = Array.prototype.concat(...provinceL);

        setProvinceList(provinceL);
      })
      .catch((err) => console.log(err));
  }, []);
  if (!loaded) {
    return null;
  }

  return (
    <Autocomplete
      disablePortal
      autoHighlight
      sx={{ minWidth: '110px' }}
      options={provinceList}
      value={deviceProvince}
      onChange={(event, values) => props.changeHandler(values ? values : null)}
      getOptionLabel={(option) => {
        return option;
      }}
      renderOption={(props, option) => (
        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
          {option}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('province')}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password' // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
}

export default DeviceProvincePicker;
